import {
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { RoleEnum, type Team } from 'api-client';

export default function TeamMembersSettings({ team, currentUserId }: { team: Team; currentUserId?: number }) {
  return (
    <Stack spacing={2} sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography component="h2" variant="h6">
        Team Members ({team.members.length})
      </Typography>
      <TableContainer component={Paper} role="region" aria-label="Team members" tabIndex={0}>
        <Table aria-label="Team membership roster" sx={{ minWidth: 480 }}>
          <TableHead>
            <TableRow>
              <TableCell>Member</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {team.members.map((member) => (
              <TableRow key={member.id}>
                <TableCell component="th" scope="row">
                  {member.displayName}
                  {member.userId === currentUserId && (
                    <Chip variant="outlined" size="small" label="You" sx={{ ml: 1 }} />
                  )}
                </TableCell>
                <TableCell>{member.role === RoleEnum.Admin ? 'Administrator' : 'Member'}</TableCell>
                <TableCell>
                  {(team.isAdmin || member.userId === currentUserId) && team.slug && (
                    <Button
                      size="small"
                      component={RouterLink}
                      to={`/teams/member/${encodeURIComponent(team.slug)}/${member.id}`}
                    >
                      View Details
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!team.isAdmin && (
        <Typography color="text.secondary">
          You can view your membership and leave the team. Administrators manage other members.
        </Typography>
      )}
    </Stack>
  );
}
